import { useCallback, useEffect } from 'react';
import { useStoreon } from 'storeon/react';
import { analytics } from '../../../../utils/analytics';
import { State } from '../../../../store/types';
import { EXECUTE_LOGOUT } from '../../../../actions';
import { loadRefreshScript } from './load-refresh-script';
import { DOMAuthEvents } from './dom-events';

export const useAuthLogic = () => {
  const { dispatch, model } = useStoreon<State>('model');

  const navigateToLoginUrl = useCallback(() => {
    if (model) window.location.href = model?.header?.initUrl || '';
  }, [model]);

  const login = useCallback(() => {
    analytics.sendEvent('GA:click', { name: 'login', position: 'header-account-popup' });
  }, []);

  const logout = useCallback(() => {
    if (!model) return;

    analytics.sendEvent('GA:click', { name: 'logout', position: 'header-account-popup' });
    dispatch(EXECUTE_LOGOUT.request);
  }, [model, dispatch]);

  useEffect(() => {
    const { hash } = window.location;

    if (hash === '#auth') {
      navigateToLoginUrl();
    }
  }, [navigateToLoginUrl]);

  useEffect(() => {
    const cb = () => navigateToLoginUrl();
    document.addEventListener(DOMAuthEvents.FORM_AUTH_OPEN, cb, { passive: true });

    return () => document.removeEventListener(DOMAuthEvents.FORM_AUTH_OPEN, cb);
  }, [navigateToLoginUrl]);

  // loadRefreshScript has check to avoid adding script multiple times
  useEffect(() => loadRefreshScript(model?.header?.refreshUrl), [model]);

  return {
    authPopup: false,
    login,
    logout,
  };
};
